module.exports = __webpack_public_path__ + "static/img/kakao-cs.478adfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kakao-cs.jpg
// module id = OT6T
// module chunks = 0